<div [formGroup]="gs.gastroForm">
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <div class="w50" style="height: 50px">
      <section class="m-box fulltext">
        <h2>Medical History</h2>
        <button class="t-btn-smart" *ngIf="!es.isClosed && ls.premissions?.Questionnaires" style="margin-bottom: 0.5em" [disabled]="aiSummaryLoading" (click)="getAiSummary()">
          {{ 'GUI.General.Buttons.Populate Smart History' | translate }}
          <span *ngIf="aiSummaryLoading" class="t-btn-smart-spinner"></span>
        </button>
        <textarea formControlName="MedicalHistory" class="scroller scroller-intro fulltext"
          style="min-height: 10em"></textarea>
        <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
            atS.showAuto(
              gs.gastroForm?.get('MedicalHistory'),
              'Medical History',
              700
            )
          ">
          Auto Text
        </button>
      </section>
    </div>
    <div class="w50 summary-anamnesis" style="display: flex">
      <div class="summary-anamnesis"></div>
      <div class="w100 summary-recommendations" style="height: 100%; padding: 0">
        <section class="m-box fulltext" style="height: 100%">
          <h2>Purpose of Exam</h2>
          <textarea formControlName="ReasonExamination" class="scroller scroller-intro fulltext"
            style="min-height: 10em"></textarea>
          <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
              atS.showAuto(
                gs.gastroForm?.get('ReasonExamination'),
                'Reason Examination',
                701
              )
            ">
            Auto Text
          </button>
        </section>
      </div>
    </div>
  </div>
  <!-- Neck and Soft Tissues Section (צוואר) -->
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <div class="w100">
      <section class="m-box fulltext" style="height: 10em;">
        <h2>Neck and Soft Tissues</h2>
        <textarea formControlName="NeckandSoftTissues" class="scroller scroller-intro fulltext"></textarea>
        <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('NeckandSoftTissues'), 'Neck and Soft Tissues', 20000)">
          Auto Text
        </button>
      </section>
    </div>
  </div>

  <!-- Shoulder Section (כתפיים) -->
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <section class="m-box w100">
      <h2>Shoulder</h2>
      <div class="h100 l-flex-w t-boxMargin--spacebyPadding">
        <div class="w50">
          <section class="m-box">
            <h2>Left</h2>
            <textarea formControlName="ShoulderLeft" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('ShoulderLeft'), 'Left Shoulder', 20003)">
              Auto Text
            </button>
          </section>
        </div>
        <div class="w50">
          <section class="m-box">
            <h2>Right</h2>
            <textarea formControlName="ShoulderRight" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('ShoulderRight'), 'Right Shoulder', 20002)">
              Auto Text
            </button>
          </section>
        </div>
      </div>
    </section>
  </div>

  <!-- Elbow Section (מרפק) -->
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <section class="m-box w100">
      <h2>Elbow</h2>
      <div class="h100 l-flex-w t-boxMargin--spacebyPadding">
        <div class="w50">
          <section class="m-box">
            <h2>Left</h2>
            <textarea formControlName="ElbowLeft" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('ElbowLeft'), 'Left Elbow', 20007)">
              Auto Text
            </button>
          </section>
        </div>
        <div class="w50">
          <section class="m-box">
            <h2>Right</h2>
            <textarea formControlName="ElbowRight" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('ElbowRight'), 'Right Elbow', 20006)">
              Auto Text
            </button>
          </section>
        </div>
      </div>
    </section>
  </div>

  <!-- Wrist Section (שורש כף היד) -->
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <section class="m-box w100">
      <h2>Wrist</h2>
      <div class="h100 l-flex-w t-boxMargin--spacebyPadding">
        <div class="w50">
          <section class="m-box">
            <h2>Left</h2>
            <textarea formControlName="WristLeft" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('WristLeft'), 'Left Wrist', 20011)">
              Auto Text
            </button>
          </section>
        </div>
        <div class="w50">
          <section class="m-box">
            <h2>Right</h2>
            <textarea formControlName="WristRight" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('WristRight'), 'Right Wrist', 20010)">
              Auto Text
            </button>
          </section>
        </div>
      </div>
    </section>
  </div>

  <!-- Hand Section (כף היד) -->
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <section class="m-box w100">
      <h2>Hand</h2>
      <div class="h100 l-flex-w t-boxMargin--spacebyPadding">
        <div class="w50">
          <section class="m-box">
            <h2>Left</h2>
            <textarea formControlName="HandLeft" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('HandLeft'), 'Left Hand', 20015)">
              Auto Text
            </button>
          </section>
        </div>
        <div class="w50">
          <section class="m-box">
            <h2>Right</h2>
            <textarea formControlName="HandRight" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('HandRight'), 'Right Hand', 20014)">
              Auto Text
            </button>
          </section>
        </div>
      </div>
    </section>
  </div>

  <!-- Pelvic Section (אגן) -->
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <div class="w100">
      <section class="m-box fulltext" style="height: 10em;">
        <h2>Pelvic</h2>
        <textarea formControlName="Pelvic" class="scroller scroller-intro fulltext"></textarea>
        <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('Pelvic'), 'Pelvic', 20001)">
          Auto Text
        </button>
      </section>
    </div>
  </div>

  <!-- Knee Section (ברכיים) -->
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <section class="m-box w100">
      <h2>Knee</h2>
      <div class="h100 l-flex-w t-boxMargin--spacebyPadding">
        <div class="w50">
          <section class="m-box">
            <h2>Left</h2>
            <textarea formControlName="KneeLeft" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('KneeLeft'), 'Left Knee', 20005)">
              Auto Text
            </button>
          </section>
        </div>
        <div class="w50">
          <section class="m-box">
            <h2>Right</h2>
            <textarea formControlName="KneeRight" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('KneeRight'), 'Right Knee', 20004)">
              Auto Text
            </button>
          </section>
        </div>
      </div>
    </section>
  </div>

  <!-- Ankle Section (קרסול) -->
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <section class="m-box w100">
      <h2>Ankle</h2>
      <div class="h100 l-flex-w t-boxMargin--spacebyPadding">
        <div class="w50">
          <section class="m-box">
            <h2>Left</h2>
            <textarea formControlName="AnkleLeft" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('AnkleLeft'), 'Left Ankle', 20009)">
              Auto Text
            </button>
          </section>
        </div>
        <div class="w50">
          <section class="m-box">
            <h2>Right</h2>
            <textarea formControlName="AnkleRight" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('AnkleRight'), 'Right Ankle', 20008)">
              Auto Text
            </button>
          </section>
        </div>
      </div>
    </section>
  </div>

  <!-- Foot Section (כף רגל) -->
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <section class="m-box w100">
      <h2>Foot</h2>
      <div class="h100 l-flex-w t-boxMargin--spacebyPadding">
        <div class="w50">
          <section class="m-box">
            <h2>Left</h2>
            <textarea formControlName="FootLeft" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('FootLeft'), 'Left Foot', 20013)">
              Auto Text
            </button>
          </section>
        </div>
        <div class="w50">
          <section class="m-box">
            <h2>Right</h2>
            <textarea formControlName="FootRight" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('FootRight'), 'Right Foot', 20012)">
              Auto Text
            </button>
          </section>
        </div>
      </div>
    </section>
  </div>
  
  <app-gastro-summary [hideSignature]="true"></app-gastro-summary>
  
  <app-exam-diagnoses></app-exam-diagnoses>

  <div class="w100 summary">
    <section class="m-box">
      <h2>Summary of Exam</h2>
      <angular-editor formControlName="Summary" [config]="editorConfig" style="width: 100%"></angular-editor>
      <button class="t-btn-edit" *ngIf="! es.isClosed" (click)="atS.showAuto(gs.gastroForm.get('Summary'),'Summary',712, true, true)">Auto Text</button>
    </section>
  </div>

  <!-- =============== Exam Signature (Start) =============== -->
  <app-gastro-summary [signOnly]="true"></app-gastro-summary>
  <!-- =============== Exam Signature (End) =============== -->
</div>
